import { render, staticRenderFns } from "./ClientEmailList.vue?vue&type=template&id=71cf6af6&scoped=true"
import script from "./ClientEmailList.vue?vue&type=script&lang=js"
export * from "./ClientEmailList.vue?vue&type=script&lang=js"
import style0 from "./ClientEmailList.vue?vue&type=style&index=0&id=71cf6af6&prod&scoped=true&lang=css"
import style1 from "./ClientEmailList.vue?vue&type=style&index=1&id=71cf6af6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cf6af6",
  null
  
)

export default component.exports